import firebase from 'firebase/app';

export default function sendEventToAnalytics(event, eventParams = {}) {
  firebase.analytics().logEvent(event, eventParams);
}
